import { Box, Grid, Typography } from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { isGroupComplete } from '../../utils/completionUtils';
import { INF_STATISTIC_FIELD_LABELS } from '../constants';

interface EquationProps {
  equation: string;
}

export const Equation = memo(function Equation(props: EquationProps) {
  const { equation } = props;

  return (
    <Grid id="inf-equation" container spacing={2} marginBottom={3}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <GroupStatusIcon isComplete={isGroupComplete(equation)} />
          <Typography my={2} fontWeight={600}>
            Equação de Regressão
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.equation}
        </Typography>
        <Typography>{equation || '-'}</Typography>
      </Grid>
    </Grid>
  );
});
